import mixpanel from "mixpanel-browser";
import type { AnalyticsProvider } from "common/analytics";

// The ONLY new-path importer of mixpanel-browser. Implements the shared, platform-agnostic
// AnalyticsProvider contract for web; injected via setProvider() in init.ts.
export const webMixpanelProvider: AnalyticsProvider = {
  init: (token, opts) => mixpanel.init(token, opts),
  track: (name, props) => mixpanel.track(name, props),
  identify: (distinctId) => mixpanel.identify(distinctId),
  reset: () => mixpanel.reset(),
  register: (superProps) => mixpanel.register(superProps),
  setUserProperties: (userProps) => mixpanel.people.set(userProps),
  getDistinctId: () => mixpanel.get_distinct_id() ?? null,
};
